@if (reports.length) {
  <div class="reports-section">
    <h4>REPORTS</h4>
    <ul class="reports">
      @for (report of reports; track report) {
        <li>
          <a
            href="#"
            class="open-link"
            (click)="$event.preventDefault(); openReport($event, report)"
            ><mat-icon>bar_chart</mat-icon>{{ report.name }}</a
            >
            <a
              class="open-link"
              href="#"
              matTooltip="Open in new window"
              (click)="embeddedReporsService.popupReport($event, report, filterSet)">
              <mat-icon inline>open_in_new</mat-icon>
            </a>
          </li>
        }
      </ul>
    </div>
  }
  @if (reports.length) {
    <hr />
  }
